import { render, staticRenderFns } from "./ProducerControl.vue?vue&type=template&id=4cd30a74&"
import script from "./ProducerControl.vue?vue&type=script&lang=js&"
export * from "./ProducerControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports